module.exports = __webpack_public_path__ + "static/media/product17.98880ef3.jpg";